import Unauthorized from '@app/views/Unauthorized';
import { memo } from 'react';

export default memo(Unauthorized);
